<template>
  <div class="page-shell page-shell--customer-manage">
    <section class="page-shell__content">
      <div class="page-shell__panel">
        <public-table
          :is_table="true"
          v-loading="listLoading"
          :column="column"
          :enableSearch="true"
          :searchItems="searchItems"
          :tableData="customerList"
          :PageInfo="listQuery"
          :onAdd="
            () => {
              (editCustomer = {}), (showEditCustomer = true);
            }
          "
          addPerm="Market.Customer.Create"
          @handlePaginationChange="getCustomerList"
        >
          <template v-slot:createTime="{ row }">{{
            row.createTime ? timetrans(row.createTime) : '-'
          }}</template>
          <template v-slot:LatestBuyAppRecoder="{ row }">
            <router-link
              v-if="row.LatestBuyAppRecoder"
              :to="{
                name: 'StoreAppManageDetails',
                params: {
                  appID: row.LatestBuyAppRecoder.appKeyID,
                  tabMode: 'detail'
                }
              }"
              >{{
                row.LatestBuyAppRecoder && row.LatestBuyAppRecoder.appName
              }}</router-link
            >
          </template>
          <template v-slot:customerID="{ row }">
            <el-button
              size="mini"
              v-permit="'Market.Customer.Update'"
              type="text"
              @click="editCustomerHandle(row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              v-permit="'Market.Customer.Delete'"
              type="text"
              @click="deleteCustomer(row)"
              >删除</el-button
            >
          </template>
        </public-table>
      </div>
    </section>
    <eidt-customer
      :customer="editCustomer"
      :onSuccess="successEdit"
      :dialogVisible="showEditCustomer"
      :onClose="() => (showEditCustomer = false)"
      :marketID="marketID"
    ></eidt-customer>
  </div>
</template>
<script>
import { deleteCustomer, fetchCustomerList } from '@/api/customer';
import { errorHandle } from '@/utils/error';
import { timetrans } from '@/utils/validate';
import EditCustomer from './components/editCustomer';
const defaultListQuery = {
  page: 1,
  size: 10
};

export default {
  name: 'CustomerManage',
  components: {
    'eidt-customer': EditCustomer
  },
  data() {
    return {
      customerForm: {
        type: 'all'
      },
      searchItems: [
        {
          label: '查询场景',
          name: 'scenes',
          value: '',
          span: 9,
          type: 'select',
          options: [
            {
              label: '全部客户',
              value: ''
            },
            {
              label: '我创建的客户',
              value: 'myCreate'
            },
            {
              label: '我负责的客户',
              value: 'myHead'
            },
            {
              label: '所属机构的客户',
              value: 'myOrg'
            },
            {
              label: '所属下级机构的客户',
              value: 'mySubOrg'
            }
          ]
        },
        {
          label: '客户名称',
          name: 'query',
          span: 9,
          value: '',
          type: 'input'
        }
      ],
      listQuery: Object.assign({}, defaultListQuery),
      customerList: [],
      listLoading: true,
      timetrans: timetrans,
      editCustomer: {},
      showEditCustomer: false,
      column: [
        {
          prop: 'customerName',
          label: '名称'
        },
        {
          prop: 'contactName',
          label: '联系人'
        },
        {
          prop: 'contactPhone',
          label: '联系手机'
        },
        {
          prop: 'createUser',
          label: '创建人'
        },
        {
          prop: 'headOrg',
          label: '负责机构'
        },
        {
          prop: 'headUser',
          label: '负责人'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '180px',
          scopeStatus: true
        },
        {
          prop: 'buyAppRecoderCount',
          label: '购买应用次数'
        },
        {
          prop: 'LatestBuyAppRecoder',
          label: '上次交付应用',
          scopeStatus: true
        },
        {
          prop: 'customerID',
          label: '操作',
          scopeStatus: true
        }
      ]
    };
  },
  created() {
    this.getCustomerList();
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    sidebar() {
      return this.$store.state;
    }
  },
  methods: {
    handleOpenAdd() {
      this.dialogtag = true;
      this.enValidateForm.name = '';
    },
    getCustomerList(param) {
      if (param) {
        this.listQuery = Object.assign(this.listQuery, param);
      }
      this.listLoading = true;
      this.listQuery.marketID = this.marketID;
      fetchCustomerList(this.listQuery)
        .then((res) => {
          if (res && res.customers) {
            this.customerList = res.customers;
            this.listQuery.total = res.total;
          } else {
            this.customerList = [];
            this.listQuery.total = res.total;
          }
          this.listLoading = false;
        })
        .catch((err) => {
          if (err) {
            this.listLoading = false;
          }
        });
    },
    handleDelete(row) {
      this.$store
        .dispatch('DeleteCustomer', {
          EID: row.enterprise_parent,
          customerID: row.enterprise_id
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.getUserList();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        })
        .catch((err) => {
          if (err) {
          }
        });
    },
    editCustomerHandle(row) {
      this.editCustomer = row;
      this.showEditCustomer = true;
    },
    successEdit() {
      this.showEditCustomer = false;
      this.getCustomerList();
    },
    deleteCustomer(row) {
      this.$confirm('确认要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteCustomer({
            marketID: this.marketID,
            customerID: row.customerID
          })
            .then((res) => {
              this.$message.success('删除成功');
              this.getCustomerList();
            })
            .catch((err) => {
              errorHandle(err);
            });
        })
        .catch(() => {});
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/customerManage/index.vue